import { render, staticRenderFns } from "./RevivedNumbers.vue?vue&type=template&id=ee47a5ca&lang=pug&"
import script from "./RevivedNumbers.vue?vue&type=script&lang=js&"
export * from "./RevivedNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports